import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const ErrorPageStyle = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  display: block;
  text-align: center;
  width: 100%;
  z-index: 1;

  p {
    font-weight: ${Variable.regular};
    font-size: 1.7rem;
  }
  .link-as-btn {
    display: inline-block;
    max-width: 90%;

    @media only screen and (min-width: ${Variable.mobile}) {
      max-width: 260px;
    }
  }
`;
